import React, { useEffect, useState } from "react";
import "./ListPlans.scss";

//Components
import Button from "../../components/atoms/Button/Button";
import CreatePlan from "./CreatePlan/CreatePlan";
import CardView from "../../components/molecules/CardView/CardView";
import Input from "../../components/atoms/Input/Input";
import AnimatedCard from "../../components/molecules/AnimatedCard/AnimatedCard";
import DataTable from "../../components/organisms/DataTable/DataTable";
import ConfirmDialog from "../../components/molecules/ConfirmDialog/ConfirmDialog";

//Services
import { plan } from "../../services/plan";
import { formatPrice } from "../../utiles/Price";

const ListPlans = () => {
    const [isSelected, setIsSelected] = useState(false);
    const [plans, setPlans] = useState([]);
    const [filteredPlans, setFilteredPlans] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        itemToDelete: null,
    });

    const getPlans = async () => {
        setLoading(true);
        try {
            const response = await plan.get();
            if (response.requestCode === 200) {
                const pl = response.data.data;

                const formattedPlans = pl.map((p) => ({
                    ...p,
                    cost: formatPrice(p.cost),
                }));

                setPlans(formattedPlans);
                setFilteredPlans(formattedPlans);
            }
        } catch (error) {
            console.error("Error al obtener los planes:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!search.trim()) {
            setFilteredPlans(plans);
            return;
        }

        const searchTerm = search.toLowerCase();
        const filtered = plans.filter((plan) =>
            plan.name.toLowerCase().includes(searchTerm)
        );
        setFilteredPlans(filtered);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search, plans]);

    useEffect(() => {
        getPlans();
    }, []);

    // Definir las columnas de la tabla
    const columns = [
        {
            field: "name",
            header: "Nombre",
            sortable: true,
        },
        {
            field: "deviceCount",
            header: "Número de dispositivos",
            sortable: true,
        },
        {
            field: "cost",
            header: "Precio",
            sortable: true,
        },
        {
            field: "used",
            header: "Clientes activos",
            sortable: true,
            body: (rowData) => {
                return (
                    <span className="list-plans__badge">
                        {rowData.used || 0}
                    </span>
                );
            },
        },
    ];

    const handleEdit = (rowData) => {
        // Aquí va la lógica para editar el plan
    };

    const handleDelete = (rowData) => {
        setConfirmDialog({
            isOpen: true,
            itemToDelete: rowData,
        });
    };

    const confirmDelete = () => {
        // const rowData = confirmDialog.itemToDelete;
        // Aquí va la lógica para eliminar el plan
        // Ejemplo:
        // setPlans(plans.filter(plan => plan.id !== rowData.id));
        // setFilteredPlans(filteredPlans.filter(plan => plan.id !== rowData.id));
    };

    return (
        <CardView>
            <div className="list-plans">
                <div className="list-plans__header">
                    <h1 className="list-plans__title">Planes</h1>
                    <Button
                        text={"Crear nuevo plan"}
                        className="list-plans__addBtn degrad"
                        onClick={() => setIsSelected(true)}
                    />
                </div>

                <div className="list-plans__filters">
                    <Button
                        text={"Refrescar"}
                        onClick={getPlans}
                        className="list-plans__refresh-btn"
                    />
                    <Input
                        className="list-plans__search"
                        type="search"
                        placeholder={"Buscar planes"}
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                    />
                </div>

                <DataTable
                    data={filteredPlans}
                    columns={columns}
                    loading={loading}
                    showActions={true}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    emptyMessage="No hay planes registrados"
                    striped={true}
                    hoverable={true}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    responsiveLayout="scroll"
                />

                {isSelected && (
                    <AnimatedCard
                        setClose={setIsSelected}
                        title="Crear Nuevo Plan"
                        size="md"
                        variant="elegant"
                        coloredHeader={true}
                    >
                        <CreatePlan
                            setClose={setIsSelected}
                            getPlans={getPlans}
                        />
                    </AnimatedCard>
                )}

                <ConfirmDialog
                    isOpen={confirmDialog.isOpen}
                    onClose={() =>
                        setConfirmDialog({ isOpen: false, itemToDelete: null })
                    }
                    onConfirm={confirmDelete}
                    title="Eliminar Plan"
                    message="¿Estás seguro de que deseas eliminar este plan?"
                    itemName={confirmDialog.itemToDelete?.name}
                    confirmText="Eliminar"
                    cancelText="Cancelar"
                    type="danger"
                />
            </div>
        </CardView>
    );
};

export default ListPlans;
